<mat-accordion>
  <mat-expansion-panel #expansionPanelFilters aria-label="Filters Panel" [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title class="font-weight-bold">Mapping</mat-panel-title>
      <mat-panel-description class="justify-content-end">
        <strong class="d-flex align-items-center">
          <mat-icon class="h-auto" fontSet="fas" fontIcon="fa-filter"></mat-icon>
          {{ expansionPanelFilters.expanded ? 'Hide' : 'Show' }} Filters
        </strong>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div>
      <ng-ut-filters-form-container
        [filtersSettings]="filtersConfigs"
        [filtersFormName]="reportType"
        [gridName]="reportType"
        (saveFilters)="saveFilters($event)"
        (createReport)="createReport($event)">
      </ng-ut-filters-form-container>
    </div>
  </mat-expansion-panel>
</mat-accordion>
<div class="flex-grow-1 mt-1">
  <ng-ctms-map
    [loading]="loading"
    [traces]="traces"
    [shipments]="shipments"
    (viewPermit)="viewPermit.emit($event)"
    (viewTrainConsist)="viewTrainConsist.emit($event)"
    (viewRoute)="viewRoute.emit($event)"
    (clearRoute)="clearRoute.emit()"
  ></ng-ctms-map>
</div>r
